<template>
  <modal-dialog :isFixed="true" @close="$emit('close')">
    <div slot="header" style="border-bottom: 1px solid #eee; margin: 0 -10px" class>
      <v-layout wrap row class="mb-0 mt-2 ml-2 mr-2">
        <v-flex xs6 sm9>
          <div class="form-control">
            <input
              type="text"
              v-model="search"
              :placeholder="$t('Search')"
              @keydown.enter="onSearch"
              @input="onSearch"
            />
          </div>
        </v-flex>
        <v-flex xs6 sm3></v-flex>
      </v-layout>
    </div>

    <div slot="body">
      <div v-if="loading" class="pt-2 pb-2">
        <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
      </div>
      <template v-else>
        <Pagination
          v-model="pageNumber"
          :limit="limit"
          :total="total"
          @onChange="handleChangePage"
          :key="timestamp"
        >
          <v-layout wrap row class="mb-0">
            <v-flex xs6>
              {{ intentLabel(intent.intentname) }}
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <label class="toggle-switch small" style="vertical-align: bottom">
                <input
                  type="checkbox"
                  :checked="intent.linenoti_status"
                  @change="onChangeLinenotifyStatus(intent.id)"
                />
                <span class="toggle-slider lever round"></span>
              </label>
            </v-flex>
          </v-layout>
          <v-layout wrap style="border-top: 1px solid #eee" class="mt-2 pt-1">
            <v-flex xs12>
              <div class="form-control">
                <input
                  type="text"
                  v-model="intent.linenoti_text"
                  :placeholder="$t('Message')"
                  class="mb-0"
                  maxlength="250"
                  @change="onChangeLinenotifyText(intent.id)"
                />
              </div>
            </v-flex>
          </v-layout>
        </Pagination>
      </template>
    </div>

    <div slot="footer" style="border-top: 1px solid #eee" class="text-xs-center">
      <v-btn outline color="grey" @click="$emit('close')">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="onSaveLineNotify">{{ $t('Save') }}</v-btn>
    </div>
  </modal-dialog>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import intentApi from '@/api/intent.js'
import { handleResponse, handleApiError } from '@/api/util'
import Pagination from '@/components/elements/Pagination2.vue'
import moment from 'moment'

export default {
  props: {
    type: {
      default: 'conversation'
    }
  },
  data: function () {
    return {
      loading: true,
      search: '',
      intents: [],
      default_intent: undefined,
      pageNumber: 1,
      limit: 10,
      offset: 0,
      timestamp: moment().format('x'),
      searchTimeout: null
    }
  },
  components: {
    ModalDialog,
    ScaleLoader,
    Pagination
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted: function () {
    var vm = this
    vm.loading = true
    vm.getIntent().then(function () {
      vm.loading = false
    })
  },
  methods: {
    onSearch() {
      const vm = this
      if (vm.searchTimeout) {
        clearTimeout(vm.searchTimeout)
      }
      if (vm.loading) return false
      vm.searchTimeout = setTimeout(async () => {
        vm.loading = true
        try {
          vm.offset = 0
          vm.pageNumber = 1
          vm.timestamp = moment().format('x')
          await vm.getIntent()
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
        vm.searchTimeout = null
      }, 1000)
    },
    async handleChangePage(payload) {
      this.loading = true
      this.offset = payload.offset
      await this.getIntent()
      this.loading = false
    },
    onChangeLinenotifyStatus: function (id) {
      var vm = this
      var findIndex = vm.intents.findIndex(function (el) {
        return el.id == id
      })
      if (findIndex > -1) {
        vm.intents[findIndex].isEdit = true
        vm.intents[findIndex].linenoti_status = !vm.intents[findIndex].linenoti_status
      }
    },
    onChangeLinenotifyText: function (id) {
      var vm = this
      var findIndex = vm.intents.findIndex(function (el) {
        return el.id == id
      })
      if (findIndex > -1) {
        vm.intents[findIndex].isEdit = true
      }
    },
    onSaveLineNotify: async function () {
      let vm = this
      vm.$store.dispatch('loading')
      vm.saveAllLineNotify().then(function () {
        vm.$store.dispatch('loading')
        vm.$emit('close')
      })
    },
    saveAllLineNotify: async function () {
      let vm = this
      try {
        if (vm.intents) {
          var result = await Promise.all(
            vm.intents.map((intent) => vm.precessSaveLineNotify(intent))
          )
        }
        return result
      } catch (error) {
        return error
      }
    },
    precessSaveLineNotify: async function (intent) {
      return await this.saveLineNotify(intent)
    },
    saveLineNotify: function (intent) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (intent.isEdit) {
          let data = {
            pageid: vm.selectedBot.pageid,
            ...intent,
            a_type: 'json',
            a_val: intent.a_val.replace(/ /gim, ' '),
            context_in: intent.context_in != null ? intent.context_in : '',
            context_out: intent.context_out != null ? intent.context_out : '',
            isShow: true
          }

          data['id'] = intent.id

          api.editIntent(data, function (error, response) {
            if (error) {
              reject(error)
            }

            resolve()
          })
        } else {
          reject()
        }
      })
    },
    // TODO: ขาด Default, Welcome ไม่ได้รวมอยู่ในหน้านี้
    async getIntent() {
      const vm = this
      let params = {
        pageid: vm.selectedBot.pageid,
        limit: vm.limit,
        offset: vm.offset,
        page_intent: vm.type,
        search_intent: vm.search && vm.search.trim() ? vm.search.trim() : undefined,
        intent_name: '["{general_intent=1}","{welcome}","{default}","{default_comment_to_inbox}"]',
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      try {
        const response = await intentApi.getIntent({ params })
        await handleResponse(response)

        if (response.data.data) {
          vm.intents = response.data.data.map((intent) => {
            return {
              ...intent,
              ableToDelete: false
            }
          })
          vm.total = response.data.total_count || 0
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/ManageSingleLineNotify.vue